import { formatDate } from '@/utils/formatDate';
import { computed } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';
import { SendError } from '@/helpers';
import { Sentry } from '@/vendors/Sentry';

export const useNotifications = () => {
  const $store = useStore();

  const notificationTypes = computed(() =>
    $store.state.notifications.reduce((acc, { type }) => {
      if (!acc.includes(type)) {
        acc.push(type);
      }
      return acc;
    }, [])
  );

  const groupedNotifications = computed(() => {
    const groupedNotifications = new Map();

    const _unreadNotifications = $store.state.notifications.filter(
      ({ isRead }) => !isRead
    );
    if (_unreadNotifications.length > 0) {
      groupedNotifications.set('new', _unreadNotifications);
    }

    const _notifications = $store.state.notifications.filter(
      ({ isRead }) => isRead
    );
    for (const notification of _notifications) {
      const formattedDate = formatDate(notification.createdAt, 'DD MMMM'); // Format as '21 October'

      addToGroupedNotifications(
        groupedNotifications,
        formattedDate,
        notification
      );
    }
    return groupedNotifications;
  });

  const readAll = async () => {
    try {
      const notifications = groupedNotifications.value
        .get('new')
        .filter(({ isRead }) => !isRead)
        .map((notification) => notification.id);
      await readNotificiations(notifications);
    } catch (e) {
      Sentry.captureException(e);
      SendError(e);
    }
  };

  const addToGroupedNotifications = (
    groupedNotifications,
    key,
    notification
  ) => {
    if (!groupedNotifications.has(key)) {
      groupedNotifications.set(key, []);
    }
    groupedNotifications.get(key).push(notification);
  };

  const getSectionLabel = (day) => {
    if (day === moment().format('DD MMMM')) {
      return 'Today';
    } else if (day === moment().subtract(1, 'days').format('DD MMMM')) {
      return 'Yesterday';
    } else {
      return day;
    }
  };

  const readNotificiation = async (notification) => {
    if (notification.isRead) {
      return;
    }

    await readNotificiations([notification.id]);
  };

  const readNotificiations = async (notificationsIds) => {
    return $store.dispatch('readNotifications', {
      notifications: notificationsIds,
    });
  };
  return {
    groupedNotifications,
    readNotificiation,
    readAll,
    getSectionLabel,
    notificationTypes,
  };
};
